import { useEffect } from 'react';
import { Helmet } from 'react-helmet';

const withGTM = (WrappedComponent, gtmId = 'GTM-NX256NJF') => {
  return function GTMComponent(props) {
    useEffect(() => {
      if (process.env.REACT_APP_HOSTING_TARGET === 'picksnprizes-player-uat') {
        if (!window.dataLayer) {
          window.dataLayer = [];
        }
        
        window.dataLayer.push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
      }
    }, []);

    const isProduction = process.env.REACT_APP_HOSTING_TARGET === 'picksnprizes-player-uat';

    return (
      <>
        {isProduction && (
          <>
            <Helmet>
              <script>
                {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtmId}');`}
              </script>
            </Helmet>
          </>
        )}
        
        <WrappedComponent {...props} />
      </>
    );
  };
};

export default withGTM;
